<template>
  <NuxtLayout name="blank" v-if="websiteInfoStore.domainNotFound">
    <DomainNotFound />
  </NuxtLayout>
  <NuxtLayout name="blank" v-else-if="websiteInfoStore.serverDown">
    <ServerDown />
  </NuxtLayout>
  <NuxtLayout v-else>
    <ClientOnly>
      <NuxtRouteAnnouncer />
      <template #fallback><span class="nuxt-route-announcer" /></template>
    </ClientOnly>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
const websiteInfoStore = useWebsiteInfoStore()
</script>
